<template>
  <div class="content">
    <nav class="banner">
        <div class="swiper-container">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide">
                    <div class="slide-wrap">
                        <img src="../../assets/banner.jpg" alt="" />
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="slide-wrap">
                        <img src="../../assets/banner_description.jpg" alt="" />
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="slide-wrap">
                        <img src="../../assets/banner_award.jpg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <article class="detail">
        <img src="../../assets/item_summary.jpg" alt="" />
    </article>
    <section class="useScene">
        <img src="../../assets/use_scene.jpg" alt="" />
    </section>
    <section class="defaultBg">
        <img src="../../assets/default_bg.jpg" alt="" />
    </section>
    <footer class="icpInfo">
        <span></span>
        <a class="icpLink" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023060448号-1</a>
    </footer>
  </div>
</template>

<script>
import Swiper from 'swiper'; // 注意引入的是Swiper
import 'swiper/css/swiper.min.css' // 注意这里的引入

export default {
  name: "index",
  components: { },
  data() {
    return {
    };
  },
  mounted() {
    new Swiper ('.swiper-container', {
      effect : 'fade',
        fadeEffect: {
            crossFade: true,
        },
      loop: true,
      autoplay: true
    })
  },
  created() {
  },
  methods: {
  },
  computed: {
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.content {
  img {
    width: 100%;
  }
  .banner {
    .slide-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .slide-wrap img {
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
  }

  .icpInfo {
      text-align: center;
      font-size: 12px;
      color: gray;
      .icpLink {
          display: inline;
          color: black;
      }
  }
}
</style>
